module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }), _c('div', {
    staticClass: "title-frontMatter"
  }, [_c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Dear Reader,")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Pennington, my favorite location, is my own creation. Having lived near two attractive towns in the heart of England, I combine the best features of both, not least the picturesque buildings from olden times. My fictional town has wide streets, quaint tearooms and public gardens ablaze with flowers; there are irresistible shops with elegant clothes and jewelry, while others are filled with bargains in antique furniture and porcelain. Surrounded by lush countryside, Pennington is full of charm—a place where dreams come true.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Sincerely,")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text"
  }, [_c('img', {
    attrs: {
      "alt": "9781459262812_i0001.jpg",
      "src": "9781459262812_i0001.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478f13bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459262812_fm02.vue
// module id = 63
// module chunks = 0